import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { USERS_LOOKUP_DETAILS_QUERY } from 'graphql/user/queries'
// components
import { Input } from 'components/FormElements'
// types
import { IUsersResponse } from 'types/graphql'

interface Props {
  fields: string[]
  userId: string
}

interface Response {
  users: IUsersResponse
}

const UserDetails: React.FC<Props> = ({ fields, userId }) => {
  const { data } = useQuery<Response>(USERS_LOOKUP_DETAILS_QUERY, {
    skip: !userId,
    variables: {
      filter: {
        id: userId
      }
    }
  })

  const user = data?.users.data[0]

  if (!user) {
    return null
  }

  const worksiteNameValue = user.locations.map((item) => item.description).join(', ')
  const worksiteAddressValue = user.locations
    .filter((item) => item.geoLocation)
    .map((item) => item.geoLocation.address)
    .join('; ')

  const { eNumber, worksiteName, worksiteAddress, phone, email } = fields.reduce<Record<string, boolean>>(
    (acc, key) => {
      acc[key] = true
      return acc
    },
    {}
  )

  return (
    <React.Fragment key={user.id}>
      {eNumber && <Input label='E Number' disabled value={user.externalEmployeeId} />}
      {worksiteName && <Input label='Worksite Name' disabled value={worksiteNameValue} />}
      {worksiteAddress && <Input label='Worksite Address' disabled value={worksiteAddressValue} />}
      {phone && <Input label='Phone' disabled value={user.workPhone} />}
      {email && <Input label='Email' disabled value={user.email} />}
    </React.Fragment>
  )
}

export default UserDetails
